// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-templates----subpage-module---wrapper---3jtzs","mdList":"src-templates----subpage-module---mdList---2-k5B"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/subpage.module.css
// module id = 160
// module chunks = 89127590239909 230350374021974